import SectorQueue from './SectorQueue'

function Shipping() {
    return <SectorQueue sector="Expedição" />
}

export default Shipping
